export default __webpack_public_path__ + "static/media/Img_generators.6b28e3f4.svg";